module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av91-97725faadde2a4e6e429784be4352dd9.jpg";